export enum AwbTypeEnum {
  PAPER_AWB = "PAPER_AWB",
  EAP = "EAP",
  EAW = "EAW",
}
